module.exports = "/_next/static/images/UBC-f857566a95f880ce1b571a561131b4fd.png";